import { Component, Input, forwardRef, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { CheckboxesFieldModel } from '../../../models/checkboxes-field.model';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';

@Component({
    selector: 'agpr-checkboxes-field',
    templateUrl: './checkboxes-field.component.html',
    styleUrls: ['./checkboxes-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => CheckboxesFieldComponent)
        }
    ],
    standalone: false
})
export class CheckboxesFieldComponent extends AbstractFormFieldComponent implements OnChanges {
    @Input() declare field: CheckboxesFieldModel;
    @Input() twoColumns: boolean = false;

    showCheckboxes: boolean = true;
    checkBoxToHide: string = '';
    protected displayMessage: boolean = false;

    readonly messageSeverities = messageSeverityEnum;

    ngOnChanges(changes: SimpleChanges): void {
        if (this.field.appearCondition) {
            this.showCheckboxes = this.field.appearCondition(this.block.displayElement);
        }
        if (this.field.displayMessageCondition) {
            this.displayMessage = this.field.displayMessageCondition(this.block.displayElement);
        }
        if (this.field.hideCheckBox) {
            this.checkBoxToHide = this.field.hideCheckBox(this.block.displayElement);
        }
    }
}
